<template lang="pug">
div
  Navbar
  section.hero.is-medium.team
    .hero-body
      .container
        h1.title.has-text-white Team
        h2.subtitle.has-text-white The people behind FanFair
  br
  section.container
    h1.title About
    h2.subtitle FanFair’s mission is to create an exchange of ideas amongst passionate fans of sports and entertainment. Our platform offers fans the opportunity to experience our fresh fan-oriented content and enter their voice into the conversation.
    p FanFair was founded by four college students who share a passion for sports and entertainment. Like any diehard fans, our team had questions that the mainstream media outlets were avoiding: who would win in a 1v1, Jared Jeffriees or Rob Perez? Who would Daryl Morey draft if he could go back in time? Or how does WOJ get an edge over his competition?
    p We were tired of waiting for mainstream media outlets to answer our questions so we decided to take matters into our hands. Our platform highlights the fan’s perspective by providing content that presents familiar ideas from a new perspective.
    p Fanfair offers fans a unique package of college-driven sports & entertainment media and a platform to express their voice with us and engage with a fandom. We produce original podcasts, articles, mini-docs, YouTube series, and much more soon to come. Currently, our networks extend to Instagram, YouTube, Twitter, TikTok, Spotify, Facebook, Apple Pods, Google Podcast, Breaker, RadioPublic, and Pocket Casts. 
    p Our team is primarily based in New York City, with the majority of our team either born in Manhattan or attending NYU. Additionally, we have both creative and business team members stretching across the US and overseas. Diversity of thought and background is incredibly important to FanFair and we are committed to using our platform to display every fan’s perspective.
  br
  section.container
    .columns.is-multiline
      .column.is-half.is-flex(v-for="member in teamMembers")
        TeamMember(:member="member")
  br
  Footer
</template>

<script>
import Navbar from "@/components/Navbar.vue";
import TeamMember from "@/components/TeamMember.vue";
import Footer from "@/components/Footer.vue";

export default {
  name: "Team",

  components: {
    Navbar,
    TeamMember,
    Footer
  },

  data() {
    return {
      teamMembers: []
    };
  },

  methods: {
    // Fetch team members from Prismic
    getTeamMembers() {
      this.$prismic.client
        .query(this.$prismic.Predicates.at("document.type", "team_member"), {
          orderings: "[my.team_member.name]",
          pageSize: 50
        })
        .then(response => {
          const results = response.results;
          this.teamMembers = results.map(document => {
            const instagram =
              document.data.instagram[0] !== undefined
                ? document.data.instagram[0].text
                : undefined;

            return {
              name: document.data.name[0].text,
              hometown: document.data.hometown[0].text,
              university: document.data.university[0].text,
              email:
                document.data.email !== undefined
                  ? document.data.email[0].text
                  : "",
              instagram: instagram,
              fan: document.data.fan,
              image: document.data.image
            };
          });
        });
    }
  },

  created() {
    this.getTeamMembers();
  }
};
</script>

<style lang="scss">
.p-1 {
  padding: 1rem;
}

.team {
  background-image: url("../assets/team.jpg");
  background-color: white;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}
</style>
